import React, { memo } from 'react'

import ProfileSecurityForm from './ProfileSecurityForm'
import ProfilePersonalInfoForm from './ProfilePersonalInfoForm'

const ProfileForm = () => {
  return (
    <div className="profile_forms_container">
      <ProfilePersonalInfoForm />
      <ProfileSecurityForm />
    </div>
  )
}

export default memo(ProfileForm)
